import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EtlIngestionService } from '../../../services/etl-ingestion/etl-ingestion.service';
import { isArrayWithData } from '../../../utilities/array.helpers';

@Component({
    selector: 'creditor-autocomplete',
    templateUrl: './creditor-autocomplete.component.html',
    styleUrl: './creditor-autocomplete.component.css',
})
export class CreditorAutocompleteComponent {
    public creditors: any | null = null;
    @Input() selectedCreditor: any | null = null;
    @Output() selectedCreditorChange = new EventEmitter<any>();
    @Output() onSelect = new EventEmitter<any>();

    public filteredCreditors: any[] = [];

    @Input() cssClass: string = '';
    @Input() styleClass: string = '';

    @Input() creditorFilter?: number[];

    constructor(private etlIngestionService: EtlIngestionService) {}

    ngOnInit() {
        this.etlIngestionService.getCreditors().subscribe((res: any) => {
            if (
                !!res &&
                !!res.Creditors &&
                Array.isArray(res.Creditors) &&
                res.Creditors.length > 0
            ) {
                let creditorsToUse = res.Creditors;

                if (isArrayWithData(this.creditorFilter)) {
                    creditorsToUse = creditorsToUse.filter((c: any) =>
                        this.creditorFilter?.includes(parseInt(c.CreditorId)),
                    );
                }

                this.creditors = creditorsToUse;
            }
        });
    }

    onKeyUp(event: any) {
        if (!event.currentTarget.value) {
            this.selectedCreditorChange.emit('');
            this.onSelect.emit('');
        }
    }

    onSelectCreditor(event: any) {
        this.selectedCreditorChange.emit(this.selectedCreditor);
        this.onSelect.emit(this.selectedCreditor);
    }

    filterCreditors(event: any) {
        let filteredItems: any[] = [];
        let query = event.query;

        for (let i = 0; i < (this.creditors as any[]).length; i++) {
            let item = (this.creditors as any[])[i];
            if (
                item.CreditorId.indexOf(query) !== -1 ||
                item.CompanyName.toLowerCase().indexOf(query.toLowerCase()) !==
                    -1
            ) {
                filteredItems.push(item);
            }
        }

        this.filteredCreditors = filteredItems;
    }
}
